import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonType } from '@ascschool/interface/setting';
import { AuthQuery } from '@ascschool/core/auth/auth.query';

@Component({
  selector: 'page-btn-option',
  templateUrl: './page-btn-option.component.html',
  styleUrls: ['./page-btn-option.component.scss']
})
export class PageBtnOptionComponent implements OnInit {
  btnType: ButtonType;
  buttonTypeEnum = ButtonType;
  @Input() isAddBtn: boolean = true;
  @Input() isExcelBtn: boolean;
  @Input() isImportBtn: boolean;
  @Input() isDeleteBtn: boolean;
  @Input() isPrintBtn: boolean;
  @Output() add = new EventEmitter();
  @Output() excel = new EventEmitter();
  @Output() import = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() print = new EventEmitter();
  constructor(
    private authQuery: AuthQuery,
  ) { }

  ngOnInit() {
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
  }
  AddEvent(event: any){
    this.add.emit(event);
  }
  excelEvent(event: any){
    this.excel.emit(event);
  }
  importEvent(event: any){
    this.import.emit(event);
  }
  deleteEvent(event: any){
    this.delete.emit(event);
  }
  printEvent(event: any){
    this.print.emit(event);
  }
}
